export default {
  partNoPlaceholder: 'Zadajte číslo dielu',
  header: 'Potvrdiť',
};
